import type { CapabilityStatus } from "../types.ts";
import { pad2 } from "../utils.tsx";

export function SlideEyebrow({ index, label }: { index: number; label: string }) {
  return (
    <div className="dz-eyebrow">
      <span className="dz-eyebrow__num">{pad2(index)}</span>
      {label}
    </div>
  );
}

export function SlideHeading({
  plain,
  children,
}: {
  plain: string;
  children?: React.ReactNode;
}) {
  return (
    <h2 className="dz-slide-h">
      {plain}
      {children}
    </h2>
  );
}

export function StatusPill({ status }: { status: CapabilityStatus }) {
  return (
    <span className={`dz-status-pill dz-status-pill--${status}`}>
      <span className="dz-status-pill__dot" />
      {status.toUpperCase()}
    </span>
  );
}

export function ModuleStatusBadge({ status }: { status: CapabilityStatus }) {
  return <span className={`dz-ms dz-ms--${status}`}>{status.toUpperCase()}</span>;
}

